"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _moment = _interopRequireDefault(require("moment"));
var _cookieAsArray = require("../../../../../../../services/cookieAsArray");
var _SaveOfferToBasketModal = require("../../../../../../modals/SaveOfferToBasketModal");
var _actions = require("../../../../../store/actions");
var _constants = require("../../store/constants");
var _selectors = require("./store/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getExpiredTimestamp = function getExpiredTimestamp() {
  return (0, _moment.default)().add(12, 'h').format('X');
};
var withBasketButtonsProps = function withBasketButtonsProps(Component) {
  var WithBasketButtonsProps = function WithBasketButtonsProps(_ref) {
    var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var offerID = props.offerID,
      queryID = props.queryID,
      _onSuccessSavedOfferToBasket = props.onSuccessSavedOfferToBasket;
    var isSaved = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getIsSavedOffer2Baskets)(state, {
        offerID: offerID
      });
    });
    var dispatch = (0, _reactRedux.useDispatch)();
    var onClick = (0, _react.useCallback)(function () {
      var callbacks = {
        onSuccessRemovedOfferFromBasket: function onSuccessRemovedOfferFromBasket() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var removedOfferID = args[0];
          dispatch((0, _actions.removeSavedOfferFromBaskets)(removedOfferID));
          new _cookieAsArray.CookieAsArray(_constants.NAME_COOKIE_OF_SAVED_OFFERS_2_BASKET, getExpiredTimestamp()).remove(removedOfferID).commit();
        },
        onSuccessSavedOfferToBasket: function onSuccessSavedOfferToBasket() {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          var savedOfferID = args[0];
          dispatch((0, _actions.addSavedOffer2Baskets)(savedOfferID));
          new _cookieAsArray.CookieAsArray(_constants.NAME_COOKIE_OF_SAVED_OFFERS_2_BASKET, getExpiredTimestamp()).push(offerID).commit();
          if (_onSuccessSavedOfferToBasket) {
            _onSuccessSavedOfferToBasket.apply(void 0, args);
          }
        }
      };
      dispatch((0, _SaveOfferToBasketModal.showSaveOfferToBasketModal)(offerID, queryID, callbacks));
    }, [dispatch, offerID, _onSuccessSavedOfferToBasket, queryID]);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
      isActive: isSaved,
      onClick: onClick
    }));
  };
  return WithBasketButtonsProps;
};
var _default = exports.default = withBasketButtonsProps;